export default __webpack_public_path__ + "static/media/BB.41aefe6e.svg";